module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/feature-style1/feature-style1.component.scss
// module id = ./src/app/features/feature-style1/feature-style1.component.scss
// module chunks = main